import { render } from "./DestrancarMatricula.vue?vue&type=template&id=ee3db29e&scoped=true"
import script from "./DestrancarMatricula.vue?vue&type=script&lang=js"
export * from "./DestrancarMatricula.vue?vue&type=script&lang=js"

import "./DestrancarMatricula.vue?vue&type=style&index=0&id=ee3db29e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3db29e"]])

export default __exports__